import styled from "styled-components";

export const NavFloor = styled.div`
  padding-top: 23px;
  /* padding-bottom: 86px; */
  box-sizing: border-box;
`;

export const Nav = styled.ul`
  display: flex;
  justify-content: center;
`;

export const NavItem = styled.li`
  position: relative;

  padding: 0 36px;

  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;

  &:hover {
    color: rgba(19, 238, 179, 1);
  }

  &:not(:last-child) {
    &::after {
      content: "";
      display: block;
      position: absolute;
      height: 10px;
      width: 1px;
      border-right: 1px solid rgba(255, 255, 255, 0.3);
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }
  }
`;

export const NavLink = styled.span``;

export const CopyRight = styled.div`
  margin-top: 39px;
`;

export const CopyRightText = styled.span`
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.2);
  display: block;
  text-align: center;
  margin-bottom: 3px;

  > .clickable {
    &:hover {
        cursor: pointer;
        color: rgba(19, 238, 179, 1);
      }
  }
`;
